import PopupMenuActions from '../../../../shared/popup-menu';
import {SVGS} from '../../../../../assets/images';
import React from 'react';
import {TimeSheetItemStatus, TimeSheetItemType} from '../../../../../features/schedule/types';
import {IntlShape} from 'react-intl';
import {PopupMenuAction} from '../../../../shared/popup-menu/types';
import {Lx} from '../../../../../i18n/consts';

interface Props {
    intl: IntlShape;
    status: TimeSheetItemStatus;
    timeshiftType: TimeSheetItemType,
    hours: number;
    hideApprovable: boolean;
    hideBillable: boolean;
    disableApprovable: boolean;
    disableBillable: boolean;
    onApproveClick: () => void;
    onBillableClick: () => void;
    onAddNewShiftClick: () => void;
    onEditTimeClick: () => void;
    onCopyItemClick?: () => void;
    onDeleteItemClick?: () => void;
    disabled?: boolean;
    hideAddAction?: boolean;
    hideEditAction?: boolean;
    hideCopyAction?: boolean;
    hideDeleteAction?: boolean;
}

const TimeSheetActionMenu: React.FC<Props> = (props) => {
    const { intl, status, timeshiftType, hours, hideApprovable, hideBillable, disableBillable, disableApprovable } = props;
    const isShift = timeshiftType === TimeSheetItemType.SHIFT
    const actions: PopupMenuAction[] = [];

    if (!hideApprovable) {
        actions.push({
            name: status !== TimeSheetItemStatus.NORMAL ?
                intl.formatMessage({id: Lx.Schedule.DISAPPROVE_FORMAT}, {s: hours})
                : intl.formatMessage({id: Lx.Schedule.APPROVE_FORMAT}, {s: hours}),
            icon: status !== TimeSheetItemStatus.NORMAL ? <SVGS.DisapproveIcon/> : <SVGS.ApproveIcon/>,
            callback: () => props.onApproveClick(),
            disabled: disableApprovable
        })
    }

    if (!hideBillable) {
        actions.push({
            name: status !== TimeSheetItemStatus.NORMAL && status !== TimeSheetItemStatus.APPROVED ?
                intl.formatMessage({id: Lx.Schedule.CANCEL_BILL_FORMAT}, {s: hours})
                : intl.formatMessage({id: Lx.Schedule.BILL_SHIFT_FORMAT}, {s: hours}),
            icon: status !== TimeSheetItemStatus.NORMAL && status !== TimeSheetItemStatus.APPROVED ? <SVGS.MoneyOffIcon/> :
                <SVGS.MoneyIcon />,
            callback: () => props.onBillableClick(),
            disabled: disableBillable
        })
    }
    if (!props.hideAddAction) {
        actions.push({
            name: intl.formatMessage({id: Lx.Schedule.CREATE_NEW_TIMESHIFT_SHIFT_TO_THIS_DAY}),
            icon: <SVGS.PlusIcon/>,
            callback: props.onAddNewShiftClick
        })
    }

    if (!props.hideEditAction) {
        actions.push({
            name: intl.formatMessage({ id: isShift ? Lx.Schedule.EDIT_TIMESHIFT_SHIFT : Lx.Schedule.EDIT_TIMESHIFT_ABSENCE }),
            icon: <SVGS.EditIcon />,
            callback: props.onEditTimeClick
        })
    }

    if (props.onCopyItemClick && !props.hideCopyAction) {
        actions.push({
            name: intl.formatMessage({ id: isShift ? Lx.Schedule.COPY_TIMESHIFT_SHIFT : Lx.Schedule.COPY_TIMESHIFT_ABSENCE }),
            icon: <SVGS.CopyIcon />,
            callback: props.onCopyItemClick
        })
    }

    if (props.onDeleteItemClick && !props.hideDeleteAction) {
        actions.push({
            name: intl.formatMessage({ id: isShift ? Lx.Schedule.DELETE_TIMESHIFT_SHIFT: Lx.Schedule.DELETE_TIMESHIFT_ABSENCE }),
            icon: <SVGS.DeleteIcon />,
            callback: props.onDeleteItemClick
        })
    }

    return(
        <PopupMenuActions
            actionIcon={<SVGS.ActionIcon />}
            actions={actions}
            newGen
            size={'small'}
            disabled={props.disabled}
            //variant='bare'
        />
    )
}

export default TimeSheetActionMenu
